// Storage Service for managing localStorage operations

const StorageService = {
  // Footer Social Icons
  getFooterIcons: () => {
    try {
      const icons = localStorage.getItem('footer_social_icons');
      return icons ? JSON.parse(icons) : [];
    } catch (error) {
      console.error('Error loading footer icons:', error);
      return [];
    }
  },

  saveFooterIcons: (icons) => {
    try {
      localStorage.setItem('footer_social_icons', JSON.stringify(icons));
      return true;
    } catch (error) {
      console.error('Error saving footer icons:', error);
      return false;
    }
  },

  addIcon: (icon) => {
    const icons = StorageService.getFooterIcons();
    const newIcon = {
      id: Date.now().toString(),
      ...icon,
    };
    icons.push(newIcon);
    StorageService.saveFooterIcons(icons);
    return newIcon;
  },

  updateIcon: (id, updatedData) => {
    const icons = StorageService.getFooterIcons();
    const index = icons.findIndex(icon => icon.id === id);
    if (index !== -1) {
      icons[index] = { ...icons[index], ...updatedData };
      StorageService.saveFooterIcons(icons);
      return true;
    }
    return false;
  },

  deleteIcon: (id) => {
    const icons = StorageService.getFooterIcons();
    const filtered = icons.filter(icon => icon.id !== id);
    StorageService.saveFooterIcons(filtered);
    return true;
  },

  // Default icons
  getDefaultIcons: () => [
    { id: 'default-1', type: 'youtube', iconName: 'YouTube', link: '#youtube' },
    { id: 'default-2', type: 'instagram', iconName: 'Instagram', link: '#instagram' },
    { id: 'default-3', type: 'facebook', iconName: 'Facebook', link: '#facebook' },
    { id: 'default-4', type: 'twitter', iconName: 'Twitter', link: '#twitter' },
  ],
};

export default StorageService;
